import layout from './MLStringRichInputBox.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MLStringRichInputBoxViewModelType from '@/ViewModels/Controls/MLStringRichInputBoxViewModel';
import RichTextBoxType from '@/Controls/RichTextBox';
import LinkType from '@/Controls/Link';
import WindowType from '@/Controls/Window';

export default class MLStringRichInputBox extends Control {

    private RichTextBox = ComponentManager.getControl<typeof RichTextBoxType>('RichTextBox');
    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private Window = ComponentManager.getControl<typeof WindowType>('Window');
    private jQueryControl: JQuery;
    private richTextBox: RichTextBoxType;
    private link: LinkType;
    private window: WindowType;

    public constructor(private viewModel: MLStringRichInputBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);
        
        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }
 
    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'mlstringrichinputbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            focus: this.viewModel.isFocusable,

            invalid: this.viewModel.invalidationText,

            parentLocator: this.viewModel.parentLocator,

            locator: this.viewModel.locator,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    if (this.viewModel.isEachLanguageEqual() === true) {
                        states.push('each-language-equal');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.richTextBox != null) {
            this.richTextBox = new this.RichTextBox(this.viewModel.richTextBox);
            let tuple = this.richTextBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.link != null) {
            this.link = new this.Link(this.viewModel.link);
            let tuple = this.link.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.window != null) {
            this.window = new this.Window(this.viewModel.window);
            let tuple = this.window.getTuple();

            tuple.control.appendTo(this.jQueryControl);

            let inited = false;
            let subscribed = false;
            this.defineComputed(() => {
                if (inited) return;

                let content = this.viewModel.window.content();
                let isOpen = this.viewModel.window.isOpen();
                
                if (content.length > 0 && isOpen === true) {
                    inited = true;
                    this.viewModel.window.isBusy(true);
                    this.applyTemplateAsync(layout, content, 1, () => {
                        this.viewModel.window.isBusy(false);
                        this.window.center();

                        // Delay centering subscription to ensure it is run after the resize
                        if (!subscribed) {
                            this.defineSubscription(this.viewModel.window_isEachLanguageEqual, () => {
                                this.window.center();
                            }); 
                            subscribed = true;
                        }
                    });
                }
            });
        }
    }

    public onAfterInit(): void {
        if (this.isDisposed)
            return;

        this.window.center();
    }
}

ComponentManager.setControl('MLStringRichInputBox', MLStringRichInputBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');